<template>
  <div>
    <modal-product />
    <info-modal
      name="high-formulator-modal"
      title="Formulador de Alta Precisión"
    >
      <div>
        <p>Este formulador está en proceso de pruebas por lo que se encuentra disponible sólo para un grupo seleccionado de personas.</p>

        <p>Al hacer uso de este formulador se está accediendo a la última versión del simulador del sistema digestivo de la Cornell University, uno de los simuladores líderes en el mundo que busca mediante la alta precisión en el diseño de una dieta, obtener ahorros importantes en los costos de alimentación.</p>

        <p>Durante el periodo de pruebas el servicio puede tener interrupciones y en el caso de una alta demanda de uso puede tardar minutos en entregar un resultado.</p>

        <p>Alisur recomienda que el uso de ésta herramienta sea monitoreada por un profesional de la nutrición que pueda determinar el correcto balance de la dieta y de asignar los márgenes de seguridad de aportes nutricionales requeridos.</p>
      </div>
    </info-modal>
    <info-modal
      name="salt-modal"
      title="Información sobre las Sales Minerales"
    >
      <div class="salt-modal-info" />
    </info-modal>
    <info-modal
      name="additive-modal"
      title="Información sobre los Aditivos"
    >
      <div class="additive-modal-info" />
    </info-modal>
    <info-modal
      name="forage-modal"
      title="Información sobre forrajes"
    >
      <div class="forage-modal-info" />
    </info-modal>
    <info-modal
      name="meadow-modal"
      title="Información sobre praderas"
    >
      <div class="meadow-modal-info" />
    </info-modal>
    <grain-limit-warning-modal />
    <modal-invalid-ingredients />
    <modal-unavailable-ingredients />
    <modal-register />
    <modal-auth :rememberable="rememberable" />
    <modal-history :image="image" />
    <modals-container />
    <div class="home">
      <home-welcome
        :images="homeImages"
        :username="username"
      />
      <div class="content__formulator-container">
        <div class="content__formulator">
          <formulator-input
            :enabled-cncps-formulator="enabledCncpsFormulator"
          />
          <formulator-output />
        </div>
      </div>
      <div class="content__promotions">
        <div id="promotions__carousel">
          <promotions />
        </div>
      </div>
      <div class="content__materials">
        <div id="raw__materials__carousel">
          <raw-material />
        </div>
      </div>
      <div class="content__links" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import homeWelcome from './home/home-welcome.vue';
import formulatorInput from './formulator/formulator-input.vue';
import formulatorOutput from './formulator/formulator-output.vue';
import promotions from './promotions.vue';
import rawMaterial from './raw-materials.vue';
import store from './store';
import baggedOrder from './formulator/bagged-order';
import modalProduct from './modal-product';
import infoModal from './modals/info-modal';
import grainLimitWarningModal from './modals/grain-limit-warning-modal.vue';
import modalInvalidIngredients from './modal-invalid-ingredients.vue';
import modalUnavailableIngredients from './modal-unavailable-ingredients.vue';
import modalRegister from './modal-register';
import modalAuth from './modal-auth';
import modalHistory from './modal-history';

export default {
  store,
  components: {
    homeWelcome,
    formulatorInput,
    formulatorOutput,
    promotions,
    rawMaterial,
    modalProduct,
    infoModal,
    grainLimitWarningModal,
    modalInvalidIngredients,
    modalUnavailableIngredients,
    modalRegister,
    modalAuth,
    modalHistory,
  },
  props: {
    username: {
      type: String,
      default: '',
    },
    rememberable: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
    homeImages: {
      type: String,
      default: '',
    },
    coagraFormulator: {
      type: Boolean,
      default: false,
    },
    colunFormulator: {
      type: Boolean,
      default: false,
    },
    isColunContext: {
      type: Boolean,
      default: false,
    },
    isCoagraContext: {
      type: Boolean,
      default: false,
    },
    enabledCncpsFormulator: {
      type: Boolean,
      default: false,
    },
    ingredientsProp: {
      type: Array,
      default: () => [],
    },
    settingsLimits: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    // El tenant debe quedar seteado ANTES de setIngredients: el máximo efectivo
    // de cada slider depende de si el contexto es Coagra.
    this.$store.dispatch('updateIsCoagraWeb', {
      isCoagraWeb: this.coagraFormulator || this.isCoagraContext,
    });
    this.$store.dispatch('updateIsColunWeb', {
      isColunWeb: this.colunFormulator || this.isColunContext,
    });
    this.$store.dispatch('setIngredients', this.ingredientsProp);
    this.$store.commit('updateSettingsLimits', this.settingsLimits);
    this.hydrateModifyFlow();
  },
  mounted() {
    const header = document.getElementsByTagName('header')[0];
    header.classList.add('header--home');
    this.openProductModalFromQuery();
  },
  methods: {
    hydrateModifyFlow() {
      const params = new URLSearchParams(window.location.search);
      const modifyOrderId = params.get('modify_order_id');
      if (modifyOrderId) {
        this.$store.commit('updateModifyOrderId', modifyOrderId);
      }

      if (params.get('product')) return;

      const ingredientEntries = [];
      params.forEach((value, key) => {
        const match = key.match(/^ingredients_proportion\[(.+)\]$/);
        if (match) ingredientEntries.push({ id: match[1], value: Number(value) });
      });
      if (!ingredientEntries.length) return;

      // Separar por categoría: los sliders generales solo leen `ingredients`,
      // mientras que minerales y aditivos viven en `salts` / `additives`.
      const ingredientsById = Object.values(this.$store.state.ingredients).reduce((acc, ingredient) => {
        acc[String(ingredient.id)] = ingredient;
        return acc;
      }, {});

      const sliderValues = {};
      this.$store.getters.generalIngredients.forEach((ingredient) => {
        sliderValues[ingredient.id] = 0;
      });

      const salts = [
        { amount: 0, id: null },
        { amount: 0, id: null },
      ];
      const additives = [
        { id: null, amount: 0 },
        { id: null, amount: 0 },
        { id: null, amount: 0 },
      ];
      let saltIndex = 0;
      let additiveIndex = 0;

      ingredientEntries.forEach(({ id, value }) => {
        const ingredient = ingredientsById[String(id)];
        if (!ingredient) return;

        const amount = Number(value);
        if (['grain', 'floured', 'protein'].includes(ingredient.category)) {
          sliderValues[ingredient.id] = amount;
        } else if (ingredient.category === 'salt_alisur' && saltIndex < salts.length) {
          salts[saltIndex] = { id: ingredient.id, amount };
          saltIndex += 1;
        } else if (['additive', 'binder'].includes(ingredient.category) && additiveIndex < additives.length) {
          additives[additiveIndex] = { id: ingredient.id, amount };
          additiveIndex += 1;
        }
      });

      this.$store.commit('setIngredientFormulatorIngredients', sliderValues);
      this.$store.commit('updateIngredientFormulator', {
        salts,
        additives,
        additiveCounter: Math.max(1, additiveIndex),
        showExtension: false,
        showExtensionIngredients: additiveIndex > 1,
      });
      this.$store.commit('setSelectedTab', 'ingredient');
      this.$store.commit('setUpdated', false);

      const form = params.get('form');
      const packaging = params.get('packaging');
      const via = params.get('via');
      const formulaName = params.get('formula_name');
      const totalSackWeight = params.get('total_sack_weight');
      const tons = Number(totalSackWeight);

      if (form) {
        const formObj = this.$store.getters.allTranslatedForms.find(e => e.value === form);
        if (formObj) this.$store.dispatch('updateForm', formObj);
      }
      const packObj = this.resolveModifyPackaging(packaging, tons);
      if (packObj) this.$store.commit('updatePackaging', packObj);
      if (via) this.$store.commit('updateVia', via);
      if (formulaName) this.$store.dispatch('updateFormulaName', formulaName);
      const baggedOptions = (this.$store.getters.extendedPackagingList || [])
        .filter(option => option.weight);
      const minTons = baggedOptions.length
        ? Math.min(...baggedOptions.map(option => option.weight))
        : 5;
      if (tons >= minTons && tons <= 15) {
        this.$store.commit('updateTotalSackWeight', tons);
      } else if (modifyOrderId) {
        this.$store.commit('updateTotalSackWeight', 10);
      }

      this.$store.dispatch('inverseRecipe', { ingredients: ingredientEntries });
    },
    resolveModifyPackaging(packaging, tons) {
      if (!packaging) return null;

      return baggedOrder.resolveOrderPackaging(
        packaging,
        tons,
        this.$store.getters.extendedPackagingList,
        this.$store.getters.productPackagingList,
      );
    },
    openProductModalFromQuery() {
      const params = new URLSearchParams(window.location.search);
      const productId = params.get('product');
      if (!productId) return;

      // Al modificar un producto de catálogo se permanece en la home con las
      // toneladas originales preseleccionadas en la tarjeta; no se abre la ficha.
      if (params.get('modify_order_id')) return;

      const tons = params.get('tons');
      this.$nextTick(() => {
        this.$modal.show('conditional-modal', {
          product: { id: Number(productId) },
          tons,
        });
      });
    },
    getProducts() {
      let params = {};
      if (this.isColunContext || this.colunFormulator) {
        params = { tenant: 'colun' };
      } else if (this.isCoagraContext || this.coagraFormulator) {
        params = { tenant: 'coagra' };
      }

      axios.get('/api/v1/products.json', { params })
        .then(response => {
          const products = response.data;
          products.forEach((product) => {
            // eslint-disable-next-line camelcase
            product.kilogram_price = parseFloat(product.kilogram_price);
          });
          this.$store.state.products = products;
        })
        .catch(e => {
          alert(e);
        });
    },
  },
};
</script>
